import styled from "styled-components";

export const HeadingSubtitle = styled.p.attrs(props => ({
  className: `text-subtitle uppercase text-blue-500`
}))``;